import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Input } from "@/components/ui/input";
import { ChevronDown, Check } from "lucide-react";

export default function MultiSelect({ label, options = [], value = [], onChange, testid, width = "w-48" }) {
  const [q, setQ] = useState("");
  const shown = options.filter((o) => o.toLowerCase().includes(q.toLowerCase())).slice(0, 300);
  const toggle = (o) => onChange(value.includes(o) ? value.filter((x) => x !== o) : [...value, o]);
  return (
    <Popover onOpenChange={(o) => { if (!o) setQ(""); }}>
      <PopoverTrigger asChild>
        <button className={`${width} h-10 px-3 rounded-md border border-slate-200 bg-white text-sm flex items-center justify-between gap-2 hover:border-[#4F46E5]/50`} data-testid={testid}>
          <span className={`truncate ${value.length ? "text-[#312E81] font-medium" : "text-slate-500"}`}>{value.length ? (value.length === 1 ? value[0] : `${value.length} selected`) : label}</span>
          <ChevronDown className="w-4 h-4 text-slate-400 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-2 bg-white" align="start">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search…" className="h-8 mb-2" data-testid={`${testid}-search`} />
        <div className="max-h-64 overflow-y-auto">
          {shown.map((o) => (
            <button key={o} onClick={() => toggle(o)} className="w-full text-left px-2 py-1.5 rounded text-sm flex items-center gap-2 hover:bg-slate-50" data-testid={`${testid}-opt`}>
              <span className={`w-4 h-4 rounded border flex items-center justify-center ${value.includes(o) ? "bg-[#4F46E5] border-[#4F46E5]" : "border-slate-300"}`}>{value.includes(o) && <Check className="w-3 h-3 text-white" />}</span>
              <span className="truncate">{o}</span>
            </button>
          ))}
          {!shown.length && <div className="text-xs text-slate-400 p-2">No matches</div>}
        </div>
        {value.length > 0 && <button onClick={() => onChange([])} className="w-full text-xs text-rose-600 mt-2 py-1 hover:bg-rose-50 rounded" data-testid={`${testid}-clear`}>Clear selection</button>}
      </PopoverContent>
    </Popover>
  );
}
